export default __webpack_public_path__ + "static/media/Snd_CQ.86e04900.mp3";